import { useId } from 'react';
import { Typography } from '@ag1/ui';
import { useTranslation } from 'react-i18next';
import { AlternateFlavor, AlternateFlavorConfig } from '@portal/processes/ShopV2/ShopV2.types';
import * as styles from './FlavorSelection.css';
import { FlavorMessage } from './FlavorMessage';
import { FlavorOptionRadio } from './FlavorOptionRadio';

interface Props {
  onChange: (flavor: AlternateFlavor | AlternateFlavorConfig) => void;
  activeVariantId: string;
  flavorVariants: (AlternateFlavor | AlternateFlavorConfig)[];
  outOfStockText?: string;
}

const FlavorSelection = ({
  onChange,
  activeVariantId,
  flavorVariants,
  outOfStockText = 'This flavor is temporarily out of stock'
}: Props) => {
  const { t } = useTranslation('sharedComponents');
  const selectFlavorText = t('v53.selectFlavorText');
  const uniqueId = useId();

  if (!flavorVariants?.length) return null;

  const radioGroupName = `flavor-selection-${uniqueId}`;

  return (
    <>
      <div className={styles.container}>
        <Typography
          variant="subtitleMono"
          size="2"
          noPadding
          color="black-new"
          className={styles.selectFlavorText}>
          {`${selectFlavorText}:`}
        </Typography>

        <div className={styles.v53FlavorOptionsContainer}>
          {flavorVariants.map((flavor) => (
            <FlavorOptionRadio
              key={flavor.id}
              flavor={flavor}
              isActive={activeVariantId === flavor.id}
              onChange={onChange}
              radioGroupName={radioGroupName}
            />
          ))}
        </div>
      </div>

      <FlavorMessage
        flavorVariants={flavorVariants}
        activeVariantId={activeVariantId}
        outOfStockText={outOfStockText}
      />
    </>
  );
};

export default FlavorSelection;
